<template>
  <ClientOnly>
    <ul :class="$style['skip-links']">
      <li
        v-for="(item, index) in items"
        :key="`skip-link-${index}`"
        :class="$style['skip-links__item']">
        <Btn
          role="button"
          :aria-label="item.title"
          :href="`#${item.id}`"
          :title="item.title">
          {{ item.title }}
        </Btn>
      </li>
    </ul>
  </ClientOnly>
</template>
<script setup>
defineProps({
  items: {
    type: Array,
    default: null
  }
})
</script>
<style lang="scss" module>
.skip-links {
  display: flex;
  padding: $spacing;
  position: fixed;
  top: -9999px;
  z-index: 10000;
  width: 100%;

  &:focus,
  &:focus-within {
    top: 0;
  }

  &__item {
    margin-right: $spacing;
    list-style: none;
  }
}
</style>
